import React from 'react';
import { Spinner } from 'react-bootstrap';
import './LoadingOverlay.css';

// Preserve the existing overlay state without the legacy library's prop-type error.
export default function LoadingOverlay({ active, text, className, children }) {
  return (
    <div className={className} aria-busy={active}>
      {children}
      {active && (
        <div className="tm-blocking-loader" role="status" aria-live="polite">
          <Spinner animation="border" />
          <span>{text || 'Please wait…'}</span>
        </div>
      )}
    </div>
  );
}
